module.exports = __webpack_public_path__ + "img/about.b81f2ef2.svg";